export const VARIANTS = {
  scrollable: 'scrollable',
  fullWidth: 'fullWidth',
};
